//引入外部模組
import 'jquery-easing/jquery.easing.1.3';
import {BodyCtrl} from '@/body_ctrl';




//引入外部模組
let bodyCtrl = new BodyCtrl;



//CM背景影片
class VideoCM {
  constructor() {
    this.header     = $('header');
    this.cover      = $('#indexCover');
    this.vedio      = this.cover.find('video');
    this.slider     = this.cover.find('.sliderBox');
    this.slogan     = this.cover.find('.slogan');
    this.parallax   = $('#parallax');
    this.scrollDown = $('#scrollDown');
    this.videoW     = 1920;
    this.videoH     = 1080;
    this.rwdH       = 750;
    this.easing     = 'easeOutExpo';
    this.duration   = 500;
    this.stopPlay   = true;
  }
  //RWD高度判斷
  rwdHeight() {
    if(window.matchMedia('(max-height:' + this.rwdH + 'px)').matches){
      this.cover.css('height', $(window).innerHeight() - this.header.outerHeight());
      this.cover.addClass('removeParallax');
      this.parallax.addClass('removeParallax');
    }else{
      this.cover.css('height', $(window).innerHeight());
      this.cover.removeClass('removeParallax');
      this.parallax.removeClass('removeParallax');
      this.parallax.css('margin-top', this.cover.outerHeight() - this.header.outerHeight());
    }
  }
  //滾差
  op(scrollPosition) {
    let st          = scrollPosition;
    let scaleEase1  = st / 30;
    let scaleEase2  = st / 10;
    if(scaleEase1 >= 50){
      scaleEase1 = 50;
    }
    if(scaleEase2 >= 300){
      scaleEase2 = 300;
    }
    let scaleCss1 = 'translate3d(-50%, ' + (- scaleEase1) + '%, 0)';
    let scaleCss2 = 'translate3d(0, ' + (- scaleEase2) + '%, 0)';
    this.slider.css({
      webkitTransform: scaleCss1,
      mozTransform   : scaleCss1,
      msTransform    : scaleCss1,
      oTransform     : scaleCss1,
      transform      : scaleCss1
    });
    this.slogan.css({
      webkitTransform: scaleCss2,
      mozTransform   : scaleCss2,
      msTransform    : scaleCss2,
      oTransform     : scaleCss2,
      transform      : scaleCss2
    });
  }
  action() {
    //RWD高度判斷
    let rwdParallax = () =>{
      if(window.matchMedia('(max-height:' + this.rwdH + 'px)').matches){
        //移除滾差
        this.op(0);
      }else{
        //引入滾差
        this.op($(window).scrollTop());
      }
    }
    rwdParallax();
    $(window).on('scroll', () => {
      rwdParallax();
    });
  }
  down() {
    this.scrollDown.on('click', (event) => {
      bodyCtrl.ctrl('scrollHide'); //控制瀏覽器捲軸
      bodyCtrl.ctrl('btnLock');    //控制瀏覽器按鈕
      $('html, body').animate({
        scrollTop: this.parallax.offset().top - this.header.outerHeight()
      }, this.duration, this.easing, () => {
        bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
        bodyCtrl.ctrl('btnUnlock');  //控制瀏覽器按鈕
      });
      return false;
    });
  }
}




//整合
class VideoCover extends VideoCM {
  videoCover(){
    super.rwdHeight();
    super.action();
    super.down();
    //RWD
    $(window).on('resize', () => {
      super.rwdHeight();
      super.action();
    });
  }
}




//輸出
export {VideoCover};


// WEBPACK FOOTER //
// ./js_new/index_cover.js